const TOKEN_KEY = 'little7_admin_token'
const USER_KEY = 'little7_admin_user'
const SESSION_KEY = 'little7_admin_session_ok'

export function getToken() {
  return localStorage.getItem(TOKEN_KEY) || ''
}

export function getUser() {
  const raw = localStorage.getItem(USER_KEY)
  if (!raw) return null
  try {
    return JSON.parse(raw)
  } catch (e) {
    return null
  }
}

export function setAuthData(payload) {
  const data = payload || {}
  const token = data.token || data.access_token || data.accessToken || ''
  const user = data.user || data.profile || { name: '管理员' }

  if (token) localStorage.setItem(TOKEN_KEY, token)
  localStorage.setItem(USER_KEY, JSON.stringify(user))
  localStorage.setItem(SESSION_KEY, '1')
}

export function clearAuth() {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(USER_KEY)
  localStorage.removeItem(SESSION_KEY)
}

export function isLoggedIn() {
  return !!(getToken() || localStorage.getItem(SESSION_KEY) === '1')
}

export function getAuthHeader() {
  const token = getToken()
  return token ? { Authorization: `Bearer ${token}` } : {}
}
